import React, { useEffect, useRef, useState } from 'react';

const Reveal = ({
  children,
  delay = 0,
  y = 30,
  x = 0,
  duration = 700,
  threshold = 0.15,
  as: Tag = 'div',
  className = '',
  ...rest
}) => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    // If IntersectionObserver isn't available, show immediately.
    if (typeof IntersectionObserver === 'undefined') {
      setVisible(true);
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setVisible(true);
            io.unobserve(entry.target);
          }
        });
      },
      { threshold, rootMargin: '0px 0px -40px 0px' }
    );
    io.observe(el);

    // Safety net: if the element is already on screen at mount, reveal anyway.
    const rect = el.getBoundingClientRect();
    if (rect.top < window.innerHeight && rect.bottom > 0) {
      setVisible(true);
      io.unobserve(el);
    }

    return () => io.disconnect();
  }, [threshold]);

  const style = {
    '--reveal-y': `${y}px`,
    '--reveal-x': `${x}px`,
    '--reveal-delay': `${delay}ms`,
    '--reveal-duration': `${duration}ms`,
  };

  return (
    <Tag
      ref={ref}
      className={`reveal ${visible ? 'is-visible' : ''} ${className}`}
      style={style}
      {...rest}
    >
      {children}
    </Tag>
  );
};

export default Reveal;
